import {
  GET_INTERVAL_REPORTS,
  GET_CHARTS_REPORT,
  GET_INTERVAL_BILL_REPORT,
} from "./types";
import server from "../apis/server";
import { log_params }  from "./Utils";
export const getIntervalBillReport = (
  start_date,
  end_date,
  payment_type,
  bill_status,
  page = 1,
) => async dispatch => {
  
  const params = {
    page,
    start_date,
    end_date,
  };

  
  if (payment_type) {
    params.payment_type = payment_type;
  }

  
  if (bill_status) {
    params.bill_status = bill_status;
  }
  // log_params(params);
  const response = await server(localStorage.getItem("token")).get(
    "/bills/interval-bills/",
    {
      params: params, // Use the params object in the request
    }
  );
  dispatch({ type: GET_INTERVAL_BILL_REPORT, payload: response.data });
  return response;
};

export const getIntervalReports = (
  start_date,
  end_date,
  payment_type,
  bill_status,
  page = 1,
) => async dispatch => {
  const params = {
    page,
    start_date,
    end_date,
  };

  
  if (payment_type) {
    params.payment_type = payment_type;
  }

  
  if (bill_status) {
    params.bill_status = bill_status;
  }
  log_params(params);
  const response = await server(localStorage.getItem("token")).get(
    "/bills/interval-report/",
    {
      params: params,
    }
  );
  dispatch({ type: GET_INTERVAL_REPORTS, payload: response.data });
  return response;
};

export const getChartsReport = (
  page = 1,
  start_date,
  end_date
) => async dispatch => {
  const response = await server(localStorage.getItem("token")).get(
    "/bills/charts/",
    {
      params: {
        page,
        start_date,
        end_date,
      },
    }
  );
  dispatch({ type: GET_CHARTS_REPORT, payload: response.data });
};

// export const getDateRange = () => {
//   dispatch({ type: GET_DATE_RANGE })
// }
